import React from "react";
import { Link } from "react-router-dom";

// images locales (mets tes vraies photos ici si tu veux)
import imgEquiMixte from "../../../assets/teams/equi-mixte.jpg";
import imgFemA      from "../../../assets/teams/seniors-feminines-a.jpg";
import img4x4       from "../../../assets/teams/equipe-4x4.jpg";
import imgJeunes1   from "../../../assets/teams/jeunes-1.jpg";
import imgJeunes2   from "../../../assets/teams/jeunes-2.jpg";

type Card = { id: number; title: string; image: string; level?: string };

const items: Card[] = [
  { id: 1, title: "4x4 Équi-mixte", image: imgEquiMixte, level: "Poule 4" },
  { id: 2, title: "Seniors Féminines A (4x4)", image: imgFemA, level: "Poule 2" },
  { id: 3, title: "Équipe 4x4", image: img4x4, level: "Poule 2" },
  { id: 4, title: "Équipe Jeunes 1", image: imgJeunes1, level: "Accès" },
  { id: 5, title: "Équipe Jeunes 2", image: imgJeunes2, level: "Promotion" },
];

export const TeamsPreview: React.FC = () => {
  return (
    <section className="py-14 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">Nos équipes</h2>
          <Link
            to="/equipes"
            className="text-blue-600 hover:text-blue-700 font-medium"
          >
            Voir toutes les équipes →
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
          {items.map((it) => (
            <article key={it.id} className="group rounded-xl border border-gray-200 bg-white overflow-hidden hover:shadow-lg transition-shadow">
              {/* Conteneur avec ratio fixe pour des tailles uniformes */}
              <div className="w-full aspect-[4/3] overflow-hidden">
                <img
                  src={it.image}
                  alt={it.title}
                  className="w-full h-full object-cover object-center transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-900">{it.title}</h3>
                  {it.level && (
                    <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                      {it.level}
                    </span>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
